declare const $: any; // jQuery global
import { BookingFormValidator } from "./booking-form-validator";

function validateEventCheckout(form: any): boolean {
    const nativeForm = document.getElementById("EventBookingForm") as HTMLFormElement | null;
    const addressValid = nativeForm ? BookingFormValidator.validateCheckoutAddresses(nativeForm) : true;

    // Unobtrusive validation
    let formValid = form.valid();

    // Confirm Email must match Email
    const confirmedEmail = $("input[name=ConfirmedEmail]");
    if (!!confirmedEmail.val() && confirmedEmail.val() != $("input[name=Email]").val()) {
        formValid = false;

        confirmedEmail.addClass("input-validation-error");

        const ceValidationMsg = $("span[data-valmsg-for=ConfirmedEmail]");
        ceValidationMsg.removeClass();
        ceValidationMsg.addClass("field-validation-error");
        ceValidationMsg.text("This must match your email to confirm.");
    }

    // Billing Confirm Email must match Billing Email
    const billingConfirmedEmail = $("input[name=BillingConfirmedEmail]");
    if (!!billingConfirmedEmail.val() && billingConfirmedEmail.val() != $("input[name=BillingEmail]").val()) {
        formValid = false;

        billingConfirmedEmail.addClass("input-validation-error");

        const bceValidationMsg = $("span[data-valmsg-for=BillingConfirmedEmail]");
        bceValidationMsg.removeClass();
        bceValidationMsg.addClass("field-validation-error");
        bceValidationMsg.text("This must match your email to confirm.");
    }

    return addressValid && formValid;
}

// Used in instances of non-payment; exposed globally for inline onclick
function submitEventCheckout(): void {
    const bookingForm = $("#EventBookingForm");

    if (validateEventCheckout(bookingForm)) {
        bookingForm.submit();
        $("#updateButton").prop("disabled", true);
    }
}

(window as any).submitEventCheckout = submitEventCheckout;
export function initCheckoutPage(paymentService: any): void {
    if (!$) return;

    const form = document.getElementById("EventBookingForm") as HTMLFormElement | null;
    if (!form) return;

    const terms = form.querySelector<HTMLInputElement>("#TermsAllAgreed");
    if (!terms) return;

    // Use shared validator to setup terms validation
    BookingFormValidator.setupTermsValidation("EventBookingForm");

    // Wire invoice button -> payment service method
    const invoiceBtn = document.getElementById("invoiceButton") as HTMLElement | null;
    if (invoiceBtn) {
        invoiceBtn.setAttribute("type", "button"); // hard guarantee
        invoiceBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (!paymentService || typeof paymentService.submitEventInvoiceFromButton !== "function") {
                console.error("[checkout] paymentService missing submitEventInvoiceFromButton");
                return;
            }

            paymentService.submitEventInvoiceFromButton(invoiceBtn);
        });
    }

    const poInput = document.getElementById("PoNumber") as HTMLInputElement | null;
    const poError = document.getElementById("PoNumberError") as HTMLElement | null;

    if (poInput) {
        poInput.addEventListener("input", () => {
            if (poInput.value.trim().length) {
                poInput.classList.remove("input-validation-error");
                if (poError) {
                    poError.textContent = "";
                    poError.classList.add("d-none");
                }
            }
        });
    }
}